import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";

// import task from "../Assets/task.png";
// import discipline from "../Assets/discipline (1).png";
// import review from "../Assets/accountability.png";

import AOS from "aos";

const timelineData = [
  {
    time: "Coding Tasks",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img87983_IMG.png",
    title: "Small Coding Tasks and Debugging Exercises",
    description: [
      "Assignments that test problem-solving ability and error handling.",
      "Focus on writing clean, reusable, and optimized code.",
    ],
    thumbs: [],
    badges: [{ text: "Assignments", color: "primary" }],
  },
  {
    time: "Discipline",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img99148_IMG.png",
    title: "Weekly Discipline Scoring",
    description: [
      "Each trainee is graded on punctuality, attendance, communication, and attitude.",
      "Consistent discipline ensures eligibility for Phase 2.",
    ],
    thumbs: [],
    badges: [{ text: "Evaluation", color: "success" }],
  },
  {
    time: "Review",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img33859_IMG.png",
    title: "Mid-Review Session",
    description: [
      "Trainers provide one-on-one feedback.",
      "Identification of improvement areas in both technical and behavioral aspects.",
    ],
    thumbs: [],
    badges: [{ text: "Feedback", color: "warning text-dark" }],
  },
];

const Month3 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      id="monthtimeline"
      className="min-vh-100 position-relative overflow-hidden"
    >
      {/* Background Video */}
      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative">
        <h1
          className="text-center gradient-text mt-5 py-3 fw-bold monthtimeline"
          style={{ fontFamily: "'Merriweather', serif" }}
        >
          Mini Assignments and Discipline Check
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row" data-aos="fade-up" key={index}>
              <div
                className="timeline-time text-light fw-bold"
                data-aos="zoom-in-up"
              >
                {item.time}
              </div>
              <div className="timeline-content">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="timeline-icon"
                />
                <h4 style={{ color: " rgb(7, 223, 252)" }}>{item.title}</h4>

                {/* Description as <ul> */}
                <ul>
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                <div>
                  {item.badges.map((badge, i) => (
                    <span
                      key={i}
                      className={`badge rounded-pill bg-${badge.color} ${
                        i > 0 ? "ms-1" : ""
                      }`}
                    >
                      {badge.text}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month3;
